import { c as _c } from "react/compiler-runtime";
import Button from "@components/blocks/Button";
import CardButton from "@components/blocks/CardButton";
import RichText from "@components/RichText";
import StrapiImage from "@components/StrapiImage";
import { Icon, Title } from "@justhome/react-ui";
import { ComponentBlocksSectionText, Maybe } from "@lib/generated/graphql";
import clsx from "clsx";
import { FC, ReactElement } from "react";
interface TextPartProps {
  data?: Maybe<ComponentBlocksSectionText>;
  serifClass?: string;
  mobileSlot?: ReactElement;
  index?: number;
  headlineSize?: "md" | "lg";
  fullWidthButton?: boolean;
}
const SectionText: FC<TextPartProps> = t0 => {
  const $ = _c(48);
  const {
    data,
    serifClass,
    mobileSlot,
    index,
    headlineSize: t1,
    fullWidthButton: t2
  } = t0;
  const headlineSize = t1 === undefined ? "lg" : t1;
  const fullWidthButton = t2 === undefined ? false : t2;
  if (!data) {
    return null;
  }
  const t3 = !data.cardButton;
  let t4;
  if ($[0] !== t3) {
    t4 = clsx("flex h-full flex-col", {
      "justify-center": t3
    });
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== data.mobileLayout || $[3] !== mobileSlot) {
    t5 = data.mobileLayout === "top" && <div className="m:hidden">{mobileSlot}</div>;
    $[2] = data.mobileLayout;
    $[3] = mobileSlot;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== data.overlineImage) {
    t6 = data.overlineImage?.data && <div className="relative h-[120px] w-[340px] m:h-[200px] my-m"><StrapiImage fill={true} sizes="340px" image={data.overlineImage} className="object-contain object-left" /></div>;
    $[5] = data.overlineImage;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== data.overline || $[8] !== serifClass) {
    t7 = data.overline && <Title as="span" className="text-overline-1-serif" serifClass={serifClass}>{data.overline}</Title>;
    $[7] = data.overline;
    $[8] = serifClass;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== data.title || $[11] !== headlineSize || $[12] !== index || $[13] !== serifClass) {
    t8 = data.title && <Title className={headlineSize === "lg" ? "text-d3 mb-3s" : "text-h2 mb-3s"} serifClass={serifClass} as={index === 0 ? "h1" : "h2"}>{data.title}</Title>;
    $[10] = data.title;
    $[11] = headlineSize;
    $[12] = index;
    $[13] = serifClass;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="mt-m m:mt-none">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== data.mobileLayout || $[19] !== mobileSlot) {
    t10 = data.mobileLayout === "afterTitle" && <div className="m:hidden">{mobileSlot}</div>;
    $[18] = data.mobileLayout;
    $[19] = mobileSlot;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== data.body) {
    t11 = data.body && <RichText className="mb-m">{data.body}</RichText>;
    $[21] = data.body;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== data.list) {
    t12 = !!data.list?.length && <ul className="space-y-3xs flex-1 mb-m">{data.list?.map(_temp)}</ul>;
    $[23] = data.list;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== data.mobileLayout || $[26] !== mobileSlot) {
    t13 = data.mobileLayout === "afterBody" && <div className="m:hidden">{mobileSlot}</div>;
    $[25] = data.mobileLayout;
    $[26] = mobileSlot;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== data.button || $[29] !== fullWidthButton) {
    t14 = data.button && <Button className={clsx("mb-m m:mb-none", {
      "!w-full": fullWidthButton
    })} {...data.button} />;
    $[28] = data.button;
    $[29] = fullWidthButton;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== data.cardButton) {
    t15 = data.cardButton && <div className="mt-xl flex-1 flex items-end mb-m m:mb-none"><CardButton {...data.cardButton} /></div>;
    $[31] = data.cardButton;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== data.mobileLayout || $[34] !== mobileSlot) {
    t16 = data.mobileLayout === "bottom" && <div className="m:hidden">{mobileSlot}</div>;
    $[33] = data.mobileLayout;
    $[34] = mobileSlot;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t15 || $[42] !== t16 || $[43] !== t4 || $[44] !== t5 || $[45] !== t6 || $[46] !== t9) {
    t17 = <div className={t4}>{t5}{t6}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
    $[43] = t4;
    $[44] = t5;
    $[45] = t6;
    $[46] = t9;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  return t17;
};
export default SectionText;
function _temp(item, index_0) {
  return <li className="flex" key={index_0}>{item?.icon && <Icon className="mr-2xs" type={item?.icon} />}<div className={clsx("text-body-2")}>{item?.text}</div></li>;
}